import { z } from 'zod';

// Common validation schemas
export const UuidSchema = z.string().uuid();

// Datetime schema that accepts both Date objects and ISO strings
export const DateTimeSchema = z.union([
  z.date(),
  z.string().refine(
    (val) => !isNaN(Date.parse(val)),
    { message: "Invalid datetime string" }
  )
]).transform((val) => {
  // Always return as string for consistency
  if (val instanceof Date) {
    return val.toISOString();
  }
  return val;
});

export const CurrencyCodeSchema = z.string().length(3);

export const PositiveNumberSchema = z.number().positive();

export const NonEmptyStringSchema = z.string().min(1);

export const EmailSchema = z.string().email();

// Pagination schema
export const PaginationSchema = z.object({
  hasMore: z.boolean(),
  nextCursor: z.string().nullable(),
});

// Weight schema
export const WeightSchema = z.object({
  user_id: UuidSchema,
  name: z.string(),
  weight: z.number().min(0),
});

// Error response schema
export const ApiErrorSchema = z.object({
  message: z.string(),
  code: z.string().optional(),
  details: z.unknown().optional(),
});

// Success response wrapper
export const createSuccessResponseSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z.object({
    success: z.literal(true),
    data: dataSchema,
  });

// Environment schema for configuration
export const EnvironmentSchema = z.object({
  VITE_API_URL: z.string().url(),
  VITE_ENVIRONMENT: z.enum(['development', 'staging', 'production']),
  VITE_ENABLE_PWA: z.string().transform(val => val === 'true').optional(),
  VITE_ENABLE_ANALYTICS: z.string().transform(val => val === 'true').optional(),
  VITE_MOCK_API: z.string().transform(val => val === 'true').optional(),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_POSTHOG_API_KEY: z.string().optional(),
  VITE_POSTHOG_HOST: z.string().optional(),
});